import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import ReactApp from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './contexts/user.context';
import { DateProvider } from './contexts/dates.context';
import { ChallengeProvider } from './contexts/challenges.context';
import { ChannelProvider } from './contexts/channel.context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <DateProvider>
          <ChallengeProvider>
            <ChannelProvider>
              <ReactApp />
            </ChannelProvider>
          </ChallengeProvider>
        </DateProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
